import { adminFetch } from '@/lib/apiClient';
import { errorFromResponse } from '@/lib/errors';
import type { AdminRole } from '@/lib/api-admin/types';
import { cleanQuery, type ClaimsQueryParams } from '../hooks/useClaimsQuery';

/**
 * QA-607 클레임 엑셀 다운로드 — `GET /api/admin/v1/claims/export`(order #127, gateway #26). 목록과 같은 검색 조건
 * (claimStatus·claimType·reasonCode·dateFrom·dateTo·q, 기간이 없으면 전체). xlsx 를 바로 내려준다(신청 상품마다 한 줄).
 */
export const CLAIM_EXPORT_ROLES: ReadonlyArray<AdminRole> = ['OPS_ADMIN', 'CS_AGENT', 'SUPER_ADMIN'];

export const claimExportPath = (params: ClaimsQueryParams): string => {
  const { page: _p, size: _s, sort: _o, ...filters } = cleanQuery(params);
  const qs = new URLSearchParams();
  for (const [k, v] of Object.entries(filters)) if (v !== undefined && v !== null && v !== '') qs.set(k, String(v));
  const query = qs.toString();
  return `/api/admin/v1/claims/export${query ? `?${query}` : ''}`;
};

const filenameOf = (res: Response): string => {
  const cd = res.headers.get('Content-Disposition') ?? '';
  const star = cd.match(/filename\*=UTF-8''([^;]+)/i);
  if (star?.[1]) return decodeURIComponent(star[1]);
  const plain = cd.match(/filename="?([^";]+)"?/i);
  if (plain?.[1]) return plain[1];
  const d = new Date();
  const pad = (n: number) => `${n}`.padStart(2, '0');
  return `claims-${d.getFullYear()}${pad(d.getMonth() + 1)}${pad(d.getDate())}.xlsx`;
};

export const downloadClaimsExcel = async (params: ClaimsQueryParams): Promise<void> => {
  const res = await adminFetch(claimExportPath(params));
  if (!res.ok) throw await errorFromResponse(res);
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filenameOf(res);
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};
